import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const Sending = types.compose(
  BaseEntity,
  types.model('Sending', {
    sendingId: types.identifierNumber,
    messageId: types.number,
    senderId: types.number,
    recipientId: types.number,
    statusId: types.number,
  }),
);
